import CheckoutStep, { CheckoutStepModelProps } from '@/models/checkout/CheckoutStep';
import Address from '@/models/geographies/Address';

// Step Data Props
export interface StepShippingAddressDataProps {
	shippingAddress: Address | null;
	taxRateSales: number;
}

// JS Model Props
export interface StepShippingAddressModelProps extends CheckoutStepModelProps {
	data: Partial<StepShippingAddressDataProps>;
}

// API Response Props
// No API props; data stored locally only

// Constructor Props
export type StepShippingAddressCtorProps = StepShippingAddressModelProps;

export default class StepShippingAddress extends CheckoutStep {

	shippingAddress: Address | null;
	taxRateSales: number;

	constructor(props: StepShippingAddressCtorProps) {
		
		const mappedProps = StepShippingAddress.mapStepDataToModel(props);

		super(props);

		this.shippingAddress = mappedProps.shippingAddress;
		this.taxRateSales = mappedProps.taxRateSales;
	}

	// Explicitly map API response to the internal model format
	private static mapStepDataToModel(props: StepShippingAddressCtorProps): StepShippingAddressDataProps {
				
		return {
			shippingAddress: props.data?.shippingAddress ?? null,
			taxRateSales: props.data?.taxRateSales ?? 0,
		};
	}
}